import { http } from '@admin-base/core'

const prefix = '/'

// 视频列表 type:video
const videoList = data => {
    return http.post(prefix + 'api/resource/video/pageList', data)
}

// 新增视频 type:video
const addVideo = data => {
    return http.post(prefix + 'api/resource/video/add', data)
}

// 编辑视频
const editVideo = data => {
    return http.post(prefix + 'api/resource/video/edit', data)
}

// 删除视频
const deleteVideo = data => {
    return http.post(prefix + `api/resource/video/delete/${data}`)
}

// 上/下架视频
const changeStatus = data => {
    return http.post(prefix + 'api/resource/video/changeStatus', data)
}

// 视频详情
const videoDetail = data => {
    return http.get(prefix + `api/resource/video/info/${data}`)
}

// 申请列表 type:video
const applyList = data => {
    return http.post(prefix + 'api/resource/video/apply/List', data)
}

// 拒绝列表 type:video
const rejectList = data => {
    return http.post(prefix + 'api/resource/video/reject/List', data)
}

// 审核视频
const videoReview = data => {
    return http.post(prefix + 'api/resource/video/review', data)
}

// 课件列表 无分页 可通过ids获取
const coursewareList = data => {
    return http.post(prefix + 'api/resource/courseware/list', data)
}

// 通过ids批量查询试卷信息
const paperBatch = data => {
    return http.post(prefix + 'api/question/examPaper/search', data)
}

// 通过ids批量查询试题信息
const questionBatch = data => {
    return http.post(prefix + 'api/question/searchByIds', data)
}

// 试卷详情
const testPaperDetail = data => {
    return http.post(prefix + `api/question/examPaper/detail`, data)
}

export {
    videoList,
    addVideo,
    editVideo,
    deleteVideo,
    changeStatus,
    videoDetail,
    applyList,
    rejectList,
    videoReview,
    coursewareList,
    paperBatch,
    questionBatch,
    testPaperDetail,
}
